import React from 'react';
import { Command } from 'cmdk';
import styles from '../CommandPalette.module.scss';

export const CommandGroup: React.FC<React.ComponentProps<typeof Command.Group>> = ({ className, ...props }) => {
  return <Command.Group className={`${styles.group} ${className ?? ''}`.trim()} {...props} />;
};

// interface CommandGroupProps {
//   group: CommandGroupType;
//   onCommandSelect: (command: CommandType, isSecondary?: boolean) => void;
//   showShortcuts?: boolean;
//   showCount?: boolean;
// }

// export const CommandGroup: React.FC<CommandGroupProps> = ({
//   group,
//   onCommandSelect,
//   showShortcuts = true,
//   showCount = false,
// }) => {
//   const visibleCommands = group.commands.filter(
//     command => !command.hidden && command.enabled !== false
//   );

//   if (visibleCommands.length === 0) {
//     return null;
//   }

//   return (
//     <GroupContainer heading={group.label}>
//       {visibleCommands.map((command) => (
//         <CommandItem
//           key={command.id}
//           command={command}
//           onSelect={onCommandSelect}
//           showShortcuts={showShortcuts}
//         />
//       ))}
//     </GroupContainer>
//   );
// };